module.exports = __webpack_public_path__ + "static/media/hugo_guedes.e594d4d7.jpg";